module.exports = __webpack_public_path__ + "img/undertakingCases28.e34f5b0e.jpg";